import { getSalarySlipFileName } from "../finance/salarySlipPdf";

const getMonthLabel = (year, month) => {
  const y = Number(year);
  const m = Number(month);
  if (!y || !m) return "";
  const monthName = new Date(y, m - 1, 1).toLocaleDateString("en-IN", { month: "long" });
  return `${monthName}, ${y}`;
};

const getTimeGreeting = (date = new Date()) => {
  const hour = date.getHours();
  if (hour < 12) return "Good Morning.";
  if (hour < 17) return "Good Afternoon.";
  return "Good Evening.";
};

export function buildSalarySlipMailPlainText({
  slip,
  senderName,
  senderTitle = "HR Team",
  companyName,
}) {
  const employeeName = slip?.employeeName || "Employee";
  const monthLabel = getMonthLabel(slip?.sheetYear, slip?.sheetMonth);
  const slipReference = String(slip?.slipNumber || "").trim() || "—";
  const orgName = String(companyName || "").trim();

  const lines = [
    `Hi ${employeeName},`,
    "",
    monthLabel
      ? `Please find attached your salary slip for the month of ${monthLabel}.`
      : `Please find attached your salary slip.`,
    "",
    "In case of any queries, please feel free to contact HR.",
    "",
    "Thanks.",
    ""
  ];

  // if (orgName) lines.push(orgName);

  return lines.join("\r\n");
}

export function buildSalarySlipMailSubject({ slip }) {
  const monthLabel = getMonthLabel(slip?.sheetYear, slip?.sheetMonth);
  return monthLabel ? `Salary Slip - ${monthLabel}` : "Salary Slip";
}

export function getSalarySlipMailAttachmentName(slip) {
  return getSalarySlipFileName(slip);
}
